import type { FrontendWidget } from '../types';
import { OfferWidgetComponent } from './OfferWidgetComponent';
import { OfferWidgetComponentB } from './OfferWidgetComponentB';
import { OfferWidgetComponentC } from './OfferWidgetComponentC';
import type { OfferWidgetConfig, OfferWidgetResolved } from './types';

export const offerWidget: FrontendWidget<
  OfferWidgetConfig,
  OfferWidgetResolved
> = {
  componentType: 'widgets.offer-widget',
  displayName: 'Offer Widget',
  defaultValues: { limit: 2, additionalTags: [] },
  ComponentA: OfferWidgetComponent,
  ComponentB: OfferWidgetComponentB,
  ComponentC: OfferWidgetComponentC,
  // No resolveSync — lookup widget. Resolved data arrives from
  // POST /api/resolve-widgets (§4 + §6).
};
